import {EsquireClient} from "@/types/clients/esquire";

export default class GetPaymentMethodsByBuildingId {
  constructor(private client: EsquireClient, private buildingId: string) {}

  public async send() {

    const url = await this.client.fetchUrlFromSession("payment-methods-by-building-id") ?? "";

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({building_id: this.buildingId})
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to get payment methods");
    }

    return await response.json();
  }
}
